<template>
  <v-container class="p-3">
    <loading-flux :value="loadingAll"></loading-flux>
    <section
      class="d-flex flex-column flex-sm-row justify-content-between"
      v-if="showHeader"
    >
      <h2 class="ml-1 my-2">
        {{ title }}
        {{
          $route.query.sap_project ? `| COD: ${$route.query.sap_project}` : ""
        }}
      </h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </section>
    <v-row align-content="start" align-md="end" class="mt-1">
      <v-col cols="12" md="12" sm="12">
        <v-btn
          @click="openModalCreateRequestMaterial"
          color="primary text-white"
          small
          v-if="!filterByUser"
        >
          <v-icon small class="mr-1"> mdi-plus </v-icon>
          Crear solicitud
        </v-btn>
        <v-btn
          class="mx-3"
          color="primary text-white"
          small
          outlined
          @click="downloadExcelRequestMaterials"
        >
          <v-icon small class="mr-1"> mdi-export </v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="mt-3">
        <label for="warehouse" class="filter-label"> Filtrar por Bodega </label>
        <v-autocomplete
          v-model="filters.warehouse"
          clearable
          disabled
          dense
          :items="warehouses.items ? warehouses.items : []"
          @input="getRequestMaterialsData(1)"
          class="filter-small"
          item-value="code"
          item-text="name"
          label="Todos"
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12" v-if="!$route.query.sap_project">
        <label for="proyect" class="filter-label"> Filtrar por Proyecto / OV </label>
        <v-autocomplete
          v-model="filters.project_code"
          clearable
          dense
          :items="
            projects.items
              ? projects.items.filter((item) => item.warehouse)
              : []
          "
          @input="changeProjectFilter()"
          @update:search-input="getProjectsData"
          @click:clear="getProjectsData"
          class="filter-small"
          hide-details
          item-text="name_code"
          no-data-text="Sin proyectos"
          :loading="loadingProjects"
          label="Todos"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
        v-if="!$route.query.sap_project && (!stockItemGroup || filterByUser)"
      >
        <div>
          <label for="proyect" class="filter-label"> Filtrar por CECO </label>
          <v-autocomplete
            v-model="filters.cost_center_filter"
            clearable
            dense
            :items="cecos.items ? cecos.items : []"
            @input="getRequestMaterialsData(1)"
            @update:search-input="getCecosData"
            @click:clear="getCecosData"
            class="filter-small"
            hide-details
            item-text="name_code"
            no-data-text="Sin CECOS"
            :loading="loadingCecos"
            label="Todos"
          ></v-autocomplete>
        </div>
      </v-col>
      <v-col cols="12" md="4" sm="12" v-if="showTypeStatusFilters">
        <label for="request-type" class="filter-label"> Filtrar por Tipo de Solicitud </label>
        <v-autocomplete
          v-model="filters.request_type_filter"
          clearable
          multiple
          dense
          :items="materialRequestTypesItems"
          @input="getRequestMaterialsData(1)"
          class="filter-small"
          hide-details
          item-text="name"
          item-value="value"
          no-data-text="Sin tipos de solicitud"
          label="Todos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12" v-if="showTypeStatusFilters">
        <label for="status" class="filter-label"> Filtrar por Estatus </label>
        <v-autocomplete
          v-model="filters.status_filter"
          clearable
          dense
          :items="statusRequestsItems"
          @input="getRequestMaterialsData(1)"
          class="filter-small"
          hide-details
          item-text="name"
          item-value="value"
          no-data-text="Sin estatus"
          label="Todos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <label for="search" class="filter-label"> Filtro de Búsqueda </label>
        <v-text-field
          v-model="filters.filter"
          @input="getRequestMaterialsData(1)"
          clearable
          dense
          class="filter-small"
          placeholder="Buscar:"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="12"></v-col>
    </v-row>
    <v-data-table
      class="elevation-3 px-3 mb-2 mt-2"
      :headers="wrappedHeaders"
      :items="wrappedRequestMaterials"
      :items-per-page="20"
      :page.sync="filters.page"
      :loading="loading"
      loading-text="Cargando solicitudes"
      item-key="id"
      hide-default-footer
      no-data-text="Sin materiales"
      @page-count="pageCount = $event"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
      :custom-sort="customSort"
    >
      <template v-slot:item.type_destiny="{ item }">
        <span class="mt-2" style="font-size: 10px">
          {{ item.project ? "Proyecto" : "CECO" }}
        </span>
      </template>

      <template v-slot:item.created_at="{ item }">
        <span class="mt-2" style="font-size: 12px">
          {{ formatDateToFormatCommon(new Date(item.created_at)) }}
        </span>
      </template>
      <template v-slot:item.received_at="{ item }">
        <span class="mt-2" style="font-size: 12px">
          {{
            item.received_at
              ? formatDateToFormatCommon(new Date(item.received_at))
              : formatDateToFormatCommon(new Date(item.created_at))
          }}
        </span>
      </template>
      <template v-slot:item.warehouse_code="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ CODE_WAREHOUSE_CENTRAL_FLUXSOLAR }}
        </span>
      </template>
      <template v-slot:item.purchase_order="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ item.purchase_order ? item.purchase_order : "-" }}
        </span>
      </template>
      <template v-slot:item.warehouse_name="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ getWarehouseCentralName }}
        </span>
      </template>
      <template v-slot:item.stage="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ item.stage ? item.stage.name : "Sin etapa" }}
        </span>
      </template>
      <template v-slot:item.material_request_type="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{
            item.is_service
              ? item.material_request_type.name == REQUEST_MATERIAL
                ? "SS"
                : "SSU"
              : item.material_request_type.name == REQUEST_MATERIAL
              ? "SM"
              : "SMU"
          }}
        </span>
      </template>
      <template v-slot:item.user="{ item }">
        <span class="mt-2" style="font-size: 11px">
          {{ item.user.email }}
        </span>
      </template>
      <template v-slot:item.warehouse_type="{ item }">
        <v-chip label small color="primary" class="mt-2 text-white">
          Central
        </v-chip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip label small :color="getColorStatus(item)" class="mt-2 text-white">
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.code="{ item }">
        <span class="mt-2" style="font-size: 10px">
          {{ item.project ? getCustomProjectCodeIfIsOv(item.project) : item.cost_center.sap_code }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalReceptionRequestMaterials(item)"
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                x-small
                class="mx-2"
              >
                <v-icon> mdi-view-list-outline </v-icon>
              </v-btn>
            </template>
            <span>Ver productos de la solicitud</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalShowRequestMaterials(item)"
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon> mdi-truck-outline </v-icon>
              </v-btn>
            </template>
            <span>Ver las solicitudes</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.warning"
                class="mx-2"
                @click="retryRemainingRequestMaterials(item)"
                icon
                color="warning"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <v-icon> mdi-sync </v-icon>
              </v-btn>
            </template>
            <span>Solicitar materiales restantes</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <div class="float-right my-3">
      <v-pagination
        v-if="requestMaterials.total_pages > 1"
        total-visible="8"
        v-model="filters.page"
        :length="requestMaterials ? requestMaterials.total_pages : 1"
      ></v-pagination>
    </div>
    <modal-create-request-material
      ref="modalCreateRequestMaterial"
      :modalAction="dialogCreateRequestMaterials"
      :closeModalCreateRequestMaterials="closeModalCreateRequestMaterials"
      :typeRequest="typeRequest"
      :stockItemGroup="stockItemGroup"
      @requestMaterialsCreated="getRequestMaterialsData"
      @approveRequestCreated="emitApproveRequestCreated"
    >
    </modal-create-request-material>
    <modal-show-request-materials
      :modalAction="dialogShowRequestMaterials"
      :closeModalShowRequestMaterials="closeModalShowRequestMaterials"
      :currentRequestMaterials="currentRequestMaterials"
      :customSapStatus="customSapStatus"
      :fromApprovals="true"
    >
    </modal-show-request-materials>
    <modal-reception-request-materials
      :modalAction="dialogReceptionRequestMaterials"
      :closeModalReceptionRequestMaterials="closeModalReceptionRequestMaterials"
      :currentRequestMaterials="currentRequestMaterialsReception"
      @receptionUpdated="getRequestMaterialsData(1)"
    >
    </modal-reception-request-materials>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalCreateRequestMaterial from "./components/ModalCreateRequestMaterial.vue";
import ModalShowRequestMaterials from "./components/ModalShowRequestMaterials.vue";
import ModalReceptionRequestMaterials from "./components/ModalReceptionRequestMaterials.vue";
import {
  CODE_WAREHOUSE_CENTRAL_FLUXSOLAR,
  REQUEST_MATERIAL,
  REQUEST_MATERIAL_URGENT,
  REQUEST_SERVICE,
  REQUEST_SERVICE_URGENT,
  TYPE_REQUESTS_MATERIALS,
  TYPE_REQUEST_MATERIAL_ID,
  TYPE_REQUEST_SERVICE_ID,
  TYPE_REQUEST_MATERIAL_OR_SERVICE,
  MATERIAL_REQUEST_TYPES_FILTER_LIST,
  STATUS_REQUEST_MATERIAL_FILTER_LIST,
  STATUS_REQUEST_MATERIAL_SAP_FILTER_LIST,
  STATUS_REQUEST_MATERIAL_OPEN,
} from "@/constants/requestMaterial";
import { authUsuarioComputed } from "@/state/helpers";
import swal from "sweetalert2";
import { formatDateToFormatCommon } from "@/helpers/common";
import { BUSINESS_UNIT_RESIDENTIAL_CODE } from "@/constants/presale";
import { getCustomProjectCodeIfIsOv } from "@/helpers/project";

export default {
  props: {
    //Prop para solicitudes de bodega móvil o solicitudes de bodegas standard
    typeRequest: {
      type: Number,
      default: TYPE_REQUESTS_MATERIALS.standard,
    },
    //Prop para titulo del componente
    title: {
      type: String,
      default: "Solicitud de Materiales",
    },
    //Prop para filtrar las solicitudes por usuario
    filterByUser: {
      type: Boolean,
      default: false,
    },
    /*Prop para solicitudes con grupo de articulos Existencia (Solicitud de Materiales) o 
    Solicitudes con grupo de articulos de NO Existencia (Solicitud de Servicios)*/
    stockItemGroup: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    /*Prop propio de la ruta /sap/request-materials: pide al backend el cálculo
    del estatus de solicitud (custom_sap_status=true) y permite al modal ocultar
    la columna "Estatus Material"*/
    customSapStatus: {
      type: Boolean,
      default: false,
    },
    //Prop para mostrar los filtros de tipo de solicitud y estatus (solo ruta /sap/request-materials)
    showTypeStatusFilters: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalCreateRequestMaterial,
    ModalReceptionRequestMaterials,
    ModalShowRequestMaterials,
  },
  mounted() {
    this.getRequestMaterialsData();
    this.getWarehousesData();
    if (!this.$route.query.sap_project) {
      this.getProjectsData();
      this.getCecosData();
    }
  },
  watch: {
    "filters.page": function(page) {
      this.getRequestMaterialsData(page);
    },
  },
  data() {
    return {
      REQUEST_MATERIAL,
      REQUEST_MATERIAL_URGENT,
      REQUEST_SERVICE,
      REQUEST_SERVICE_URGENT,
      CODE_WAREHOUSE_CENTRAL_FLUXSOLAR,
      TYPE_REQUESTS_MATERIALS,
      typeRequestsItems: TYPE_REQUEST_MATERIAL_OR_SERVICE,
      materialRequestTypesItems: MATERIAL_REQUEST_TYPES_FILTER_LIST,
      //En la ruta /sap/request-materials el backend calcula el estatus mostrado,
      //por lo que el filtro de estatus usa los valores calculados
      statusRequestsItems: this.showTypeStatusFilters
        ? STATUS_REQUEST_MATERIAL_SAP_FILTER_LIST
        : STATUS_REQUEST_MATERIAL_FILTER_LIST,
      debounceTime: 500,
      debounceProjects: null,
      debounceCecos: null,
      debounceWarehouses: null,
      debounceRequests: null,
      //Aviso de "filtro no aplicado" mostrado (backend sin respuesta de
      //entregas): se muestra una sola vez hasta volver a una respuesta normal
      statusFilterDegraded: false,
      filters: {
        page: 1,
        project_code: null,
        cost_center_filter: null,
        type_request: null,
        //Preselección de filtros (solo ruta /sap/request-materials): tipos SM y SMU y estatus Abierta
        request_type_filter: this.showTypeStatusFilters
          ? [REQUEST_MATERIAL, REQUEST_MATERIAL_URGENT]
          : null,
        status_filter: this.showTypeStatusFilters
          ? STATUS_REQUEST_MATERIAL_OPEN
          : null,
        warehouse: CODE_WAREHOUSE_CENTRAL_FLUXSOLAR,
        filter: "",
        sort_by: "created_at",
        sort_order: "desc",
      },
      pageCount: 0,
      loadingAll: false,
      loadingProjects: false,
      loadingCecos: false,
      currentRequestMaterials: null,
      currentRequestMaterialsReception: null,
      dialogCreateRequestMaterials: false,
      dialogShowRequestMaterials: false,
      dialogReceptionRequestMaterials: false,
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: this.title,
          disabled: true,
          href:
            this.typeRequest == TYPE_REQUESTS_MATERIALS.mobile_warehouses
              ? "/supplying/mobile-warehouses/requests"
              : "/sap/request-materials",
        },
      ],
      tableHeaders: [
        {
          text: "Acción",
          align: "center",
          value: "actions",
          className: "px-0",
          width: "3%",
          sortable: false,
        },
        {
          text: "Código Bodega",
          sortable: false,
          width: "5%",
          align: "center",
          value: "warehouse_code",
        },
        {
          text: "Cesta Compra",
          sortable: true,
          width: "5%",
          align: "center",
          value: "purchase_order",
        },
        {
          text: "Nombre Bodega",
          align: "center",
          value: "warehouse_name",
          sortable: false,
          width: "5%",
        },
        {
          text: "Fecha de Creación",
          align: "center",
          value: "created_at",
          width: "5%",
          sortable: true,
        },
        {
          text: "Fecha de Entrega",
          align: "center",
          value: "received_at",
          width: "5%",
          sortable: true,
        },
        {
          text: "Tipo de Solicitud",
          align: "center",
          value: "material_request_type",
          width: "5%",
          sortable: true,
        },
        {
          text: "Usuario que Solicita",
          align: "center",
          value: "user",
          width: "3%",
          sortable: true,
        },
        // {
        //   text: "Etapa Proyecto",
        //   align: "center",
        //   value: "stage",
        //   width: "8%",
        //   sortable: false,
        // },
        {
          text: "Estado Solicitud",
          align: "center",
          value: "status",
          width: "10%",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      loading: "requestMaterialsSap/loading",
      requestMaterials: "requestMaterialsSap/requestMaterials",
      projects: "requestMaterialsSap/projects",
      cecos: "requestMaterialsSap/cecos",
      warehouses: "requestMaterialsSap/warehouses",
    }),
    wrappedRequestMaterials() {
      return this.requestMaterials.items;
    },
    getWarehouseCentralName() {
      return this.warehouses.items
        ? this.warehouses.items.find(
            (item) => item.code == CODE_WAREHOUSE_CENTRAL_FLUXSOLAR,
          ).name
        : "-";
    },
    wrappedHeaders() {
      if (this.$route.query.sap_project) {
        return this.tableHeaders;
      }
      return [
        {
          text: "Proyecto",
          align: "center",
          value: "code",
          width: "20%",
          sortable: true,
        },
        ...this.tableHeaders,
      ];
    },
  },
  methods: {
    ...mapActions({
      getRequestMaterials: "requestMaterialsSap/getRequestMaterials",
      getProjects: "requestMaterialsSap/getProjects",
      getWarehouses: "requestMaterialsSap/getWarehouses",
      sendDownloadExcelRequestMaterials:
        "requestMaterialsSap/downloadExcelRequestMaterials",
      getCecos: "requestMaterialsSap/getCecos",
      sendRetryRemainingRequestMaterials:
        "requestMaterialsSap/retryRemainingRequestMaterials",
    }),
    getCustomProjectCodeIfIsOv,
    formatDateToFormatCommon(date) {
      return formatDateToFormatCommon(date);
    },
    emitApproveRequestCreated(data) {
      this.$emit("approveRequestCreated", data);
    },
    openModalCreateRequestMaterial() {
      this.dialogCreateRequestMaterials = true;
      this.filters.project_code = null;
      this.$refs.modalCreateRequestMaterial.resetFormCreateRequestMaterial();
      if (!this.$route.query.sap_project) {
        this.getProjectsData({ type: "clear" });
      }
    },
    closeModalCreateRequestMaterials() {
      this.dialogCreateRequestMaterials = false;
    },
    openModalShowRequestMaterials(requestMaterial) {
      this.currentRequestMaterials = requestMaterial;
      this.dialogShowRequestMaterials = true;
    },
    closeModalShowRequestMaterials() {
      this.currentRequestMaterials = null;
      this.dialogShowRequestMaterials = false;
    },
    openModalReceptionRequestMaterials(requestMaterial) {
      this.currentRequestMaterialsReception = requestMaterial;
      this.dialogReceptionRequestMaterials = true;
    },
    closeModalReceptionRequestMaterials() {
      this.currentRequestMaterialsReception = null;
      this.dialogReceptionRequestMaterials = false;
    },
    async changeProjectFilter() {
      let self = this;
      self.getRequestMaterialsData(1);
    },
    async getRequestMaterialsData(page = 1) {
      let self = this;
      clearTimeout(self.debounceRequests);
      self.debounceRequests = setTimeout(async () => {
        const response = await this.getRequestMaterials({
          ...this.filters,
          get_type: this.typeRequest,
          page,
          filter: this.filters.filter ? this.filters.filter : undefined,
          project_code: this.$route.query.sap_project
            ? this.$route.query.sap_project
            : this.filters.project_code
            ? this.filters.project_code.split(" - ")[0]
            : undefined,
          cost_center_filter: this.filters.cost_center_filter
            ? this.filters.cost_center_filter.split(" - ")[0]
            : undefined,
          warehouse:
            this.filters.warehouse == CODE_WAREHOUSE_CENTRAL_FLUXSOLAR
              ? undefined
              : this.filters.warehouse,
          user_filter: this.filterByUser ? this.user.email : undefined,
          is_service:
            this.filters.type_request == TYPE_REQUEST_SERVICE_ID
              ? true
              : this.stockItemGroup
              ? false
              : undefined,
          is_material:
            this.filterByUser ||
            this.filters.type_request == TYPE_REQUEST_MATERIAL_ID ||
            this.stockItemGroup
              ? true
              : undefined,
          request_type_filter:
            this.filters.request_type_filter &&
            this.filters.request_type_filter.length
              ? this.filters.request_type_filter.join(",")
              : undefined,
          status_filter: this.filters.status_filter
            ? this.filters.status_filter
            : undefined,
          //La ruta /sap/request-materials pide al backend el estatus calculado
          custom_sap_status: this.customSapStatus ? true : undefined,
        });
        if (response && response.custom_status_filter_applied === false) {
          //El backend no pudo consultar el estatus (entregas sin respuesta):
          //pagina la lista SIN aplicar el filtro calculado y lo avisa aqui.
          //Una sola vez hasta que vuelva una respuesta normal.
          if (!self.statusFilterDegraded) {
            self.statusFilterDegraded = true;
            swal.fire({
              icon: "warning",
              title: "Filtro no aplicado",
              text:
                "No se pudo consultar el estado de las solicitudes " +
                "(servicio de entregas no disponible). Se muestra la lista " +
                "sin filtrar.",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 6000,
              timerProgressBar: true,
            });
          }
        } else {
          self.statusFilterDegraded = false;
        }
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by =
          sortBy == "material_request_type"
            ? "request_type"
            : sortBy == "user"
            ? "created_by"
            : sortBy == "code"
            ? "project"
            : sortBy;
        this.filters.sort_order = "asc";
        await this.getRequestMaterialsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getRequestMaterialsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getRequestMaterialsData();
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },
    async getWarehousesData(search = null) {
      clearTimeout(this.debounceWarehouses);
      let self = this;
      this.debounceWarehouses = setTimeout(async function() {
        await self.getWarehouses({
          filter: search ? search : undefined,
          items: 30,
        });
      }, self.debounceTime);
    },
    async getProjectsData(search = "") {
      if (
        (search && search.type) ||
        ((search || typeof search == "string") &&
          this.filters.project_code !== search)
      ) {
        this.loadingProjects = true;
        clearTimeout(this.debounceProjects);
        let self = this;
        this.debounceProjects = setTimeout(async function() {
          await self.getProjects({
            is_mobile:
              self.typeRequest == TYPE_REQUESTS_MATERIALS.mobile_warehouses
                ? true
                : undefined,
            filter: search && !search.type ? search : undefined,
            items: 20,
          });
          self.loadingProjects = false;
        }, self.debounceTime);
      }
    },
    async getCecosData(search = "") {
      if (
        (search && search.type) ||
        ((search || typeof search == "string") &&
          this.filters.cost_center_filter !== search)
      ) {
        this.loadingCecos = true;
        clearTimeout(this.debounceCecos);
        let self = this;
        this.debounceCecos = setTimeout(async function() {
          await self.getCecos({
            filter: search && !search.type ? search : undefined,
            items: 20,
          });
          self.loadingCecos = false;
        }, self.debounceTime);
      }
    },
    getColorStatus(item) {
      switch (item.status) {
        case "Abierta":
          return "primary";
        case "Cerrado":
          return "green darken-2";
        case "Comprado, pendiente despacho al CD":
          return "purple darken-1";
        case "Parcialmente comprado":
          return "orange darken-1";
        case "Recibida":
          return "yellow darken-2";
        case "Parcialmente recibida":
          return "yellow darken-2";
        case "Consumida":
          return "primary";
        case "Parcialmente consumida":
          return "primary";
        case "Cerrada":
          return "red darken-3";
        case "Parcialmente cerrada":
          return "red darken-3";
        default:
          break;
      }
    },
    async downloadExcelRequestMaterials() {
      this.loadingAll = true;
      const response = await this.sendDownloadExcelRequestMaterials({
        get_type: this.typeRequest,
        project_code: this.$route.query.sap_project
          ? this.$route.query.sap_project
          : undefined,
        user_filter: this.filterByUser ? this.user.email : undefined,
      });
      let fileURL = window.URL.createObjectURL(new Blob([response]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        this.$route.query.sap_project
          ? `${this.$route.query.sap_project}_solicitudes_materiales.xlsx`
          : `solicitudes_materiales.xlsx`,
      );
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingAll = false;
    },
    async retryRemainingRequestMaterials(item) {
      swal
        .fire({
          title: "Atención",
          text: "¿Estás seguro que quieres solicitar los materiales restantes?",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, solicitar",
          cancelButtonText: "No, cancelar",
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingAll = true;
            const response = await this.sendRetryRemainingRequestMaterials({
              id: item.id,
            });
            if (response.status == 200) {
              swal.fire({
                icon: "success",
                title: "Excelente",
                text: "Materiales restantes solicitados con éxito",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 6000,
                timerProgressBar: true,
              });
              this.getRequestMaterialsData(1);
            } else if (response.status == 400) {
              swal.fire({
                icon: "error",
                title: "Error",
                text: response.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
              });
            } else {
              swal.fire({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error en el servidor, intentalo nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
              });
            }
            this.loadingAll = false;
          }
        });
    },
  },
};
</script>

<style scoped>
/* Filtros de la lista de solicitudes: tamaño visual reducido y uniforme */
.filter-label {
  font-size: 13px;
}
.filter-small::v-deep input,
.filter-small::v-deep .v-label {
  font-size: 13px;
}
</style>